if (!customElements.get('sticky-product-bar')) {
  customElements.define(
    'sticky-product-bar',
    class StickyProductBar extends HTMLElement {
      connectedCallback() {
        this.realSubmit = document.getElementById(this.dataset.submitId);
        this.stickySubmit = this.querySelector('[data-sticky-submit]');
        this.stickySubmitText = this.querySelector('[data-sticky-submit-text]');
        this.stickySample = this.querySelector('[data-sticky-sample]');

        if (!this.realSubmit || !this.stickySubmit) return;

        this.isPastButtons = false;
        this.isFooterVisible = false;

        this.onStickySubmitClick = this.onStickySubmitClick.bind(this);
        this.syncSubmitState = this.syncSubmitState.bind(this);

        this.stickySubmit.addEventListener('click', this.onStickySubmitClick);
        this.bindSample();
        this.observeVisibility();
        this.observeFooter();
        this.observeSubmitState();
      }

      disconnectedCallback() {
        if (this.visibilityObserver) this.visibilityObserver.disconnect();
        if (this.footerObserver) this.footerObserver.disconnect();
        if (this.stateObserver) this.stateObserver.disconnect();
        if (this.stickySubmit) this.stickySubmit.removeEventListener('click', this.onStickySubmitClick);
      }

      onStickySubmitClick() {
        if (this.realSubmit.disabled) return;
        this.realSubmit.click();
      }

      bindSample() {
        const anchorId = this.dataset.sampleAnchorId;
        if (!this.stickySample || !anchorId) return;

        this.stickySample.addEventListener('click', () => {
          const target = document.getElementById(anchorId);
          if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      }

      observeVisibility() {
        const watchTarget = this.realSubmit.closest('.product-form__buttons') || this.realSubmit;

        this.visibilityObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              this.isPastButtons = !entry.isIntersecting;
              this.updateVisibility();
            });
          },
          { threshold: 0 }
        );
        this.visibilityObserver.observe(watchTarget);
      }

      observeFooter() {
        const footer = document.querySelector('footer.footer');
        if (!footer) return;

        this.footerObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              this.isFooterVisible = entry.isIntersecting;
              this.updateVisibility();
            });
          },
          { threshold: 0, rootMargin: '0px 0px -1px 0px' }
        );
        this.footerObserver.observe(footer);
      }

      updateVisibility() {
        this.classList.toggle('sticky-product-bar--visible', this.isPastButtons && !this.isFooterVisible);
      }

      observeSubmitState() {
        this.syncSubmitState();
        this.stateObserver = new MutationObserver(this.syncSubmitState);
        this.stateObserver.observe(this.realSubmit, {
          attributes: true,
          attributeFilter: ['disabled'],
          childList: true,
          subtree: true,
          characterData: true,
        });
      }

      syncSubmitState() {
        this.stickySubmit.disabled = this.realSubmit.disabled;
        const label = this.realSubmit.querySelector('span');
        if (label && this.stickySubmitText) {
          this.stickySubmitText.textContent = label.textContent.trim();
        }
      }
    }
  );
}
